import React, { useState, useContext, useRef, useEffect } from "react";
import { Container, Col, Row } from "react-bootstrap";
import AuthContext from "../context/AuthContext";
import { isEmpty } from "lodash";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { apiGet ,apiPost} from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
function Home() {
  let { user, handleShow, launchCasino, homeLoader,doLoginAndLaunchRoyalCasino } = useContext(AuthContext);
  const navigate = useNavigate();
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
  };
  const [inplayCountData, setInplayCountData] = useState({});

  const inPlayCount = async () => {
    const { status, data: response_users } = await apiGet(apiPath.inPlayCount);
    if (status === 200) {
      if (response_users.success) {
        if (response_users.results) {
          setInplayCountData(response_users.results);
        }
      }
    }
  };
  const [data, setData] = useState([]);

  const getData = async () => {
    const { status, data } = await apiPost(apiPath.getBanner, {
      type: "home_top",
    });
    if (status == 200) {
      if (data?.success) {
        setData(data?.results?.banners);
      }
    }
  };
 
  useEffect(() => {
    getData();
    inPlayCount();
  }, []);
  return (
    <div>
      <div className="main">
        <Container>
        {/* <Col md={12} className="my-2">
            <Slider {...settings}>
                    {data?.length > 0 &&
                      data?.map((item) => {
                        return (
                      <div>
                        <LazyLoadImage
                        src={process.env.REACT_APP_API_BASE_URL + item?.banner_path}
                          
                          style={{ width: "100%" }}
                          alt=""
                        />
                      </div>
                    );
                    })}
                    
                    </Slider>
            </Col> */}
            <div className="gamehall-wrap-simple">
            <a href="#" neua="InPlay Banner">
              <dl className="entrance-title">
                <dt>Sports</dt>
                <dd>Play Now</dd>
              </dl>
              <dl
                id="onLiveBoard"
                onClick={() => navigate("/inplay")}
                className="on_live"
              >
                <dt>
                  <p className="live_icon">
                    <span></span> LIVE
                  </p>
                </dt>

                <dd id="onLiveCount_CRICKET">
                  <p>Cricket</p>
                  <span id="count">
                    {inplayCountData?.cricketInplayCount || 0}
                  </span>
                </dd>

                <dd id="onLiveCount_SOCCER">
                  <p>Soccer</p>
                  <span id="count">
                    {inplayCountData?.soccerInplayCount || 0}
                  </span>
                </dd>

                <dd id="onLiveCount_E_SOCCER">
                  <p>E-Soccer</p>
                  <span id="count">
                    {inplayCountData?.soccerInplayCount || 0}
                  </span>
                </dd>

                <dd id="onLiveCount_TENNIS">
                  <p>Tennis</p>
                  <span id="count">
                    {inplayCountData?.tennisInplayCount || 0}
                  </span>
                </dd>
              </dl>
              <Link to="/inplay">
                <LazyLoadImage 
                  src={
                    process.env.REACT_APP_WEB_URL +
                    "/assets/images/home/banner_sports.webp"
                  }
                  alt=""
                />
              </Link>
            </a>
            
            <a
              className="entrance"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "EVOLUTION",
                    gameType: "LIVE",
                    casinoType: "EVOLUTION-LIVE-291",
                  });
                } else {
                 handleShow();
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Kabaddi</dt>
                <dd>Play Now</dd>
              </dl>
              <LazyLoadImage 
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_kabaddi.png"
                }
                alt=""
              />
            </a>
            <a
              className="entrance"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "SABA",
                    gameType: "VIRTUAL",
                    casinoType: "SABA-VIRTUAL-001",
                  });
                } else {
                 handleShow();
                }
              }}
            >
              {/* <dl className="entrance-title">
                <dt>Kabaddi</dt>
                <dd>Play Now</dd>
              </dl> */}
              <LazyLoadImage 
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_skyexchangeBlog.png"
                }
                alt=""
              />
            </a>
            <a
              className="entrance"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "SABA",
                    gameType: "VIRTUAL",
                    casinoType: "SABA-VIRTUAL-001",
                  });
                } else {
                 handleShow();
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Virtual Cricket</dt>
                <dd>Play Now</dd>
              </dl>
              <LazyLoadImage 
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_virtualsports.png"
                }
                alt=""
              />
            </a>
            <a
                className="entrance-half"
                href="javascript:void(0)"
                onClick={() => {
                  if (!isEmpty(user)) {
                    launchCasino({
                      platForm: "EVOLUTION",
                      gameType: "LIVE",
                      casinoType: "EVOLUTION-LIVE-006",
                      isLobbyTrue:true,
                       name:'EVO'
                    });
                  } else {
                    navigate("/login");
                  }
                }}
                neua="AEIndia Banner"
              >
                <dl className="entrance-title">
                  <dt>EVO</dt>
                  <dd>Play Now</dd>
                </dl>
                <LazyLoadImage
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_evo-half.png"
                }
                  
                  alt=""
                />
              </a>
              <a
                className="entrance-half"
                href="javascript:void(0)"
                onClick={() => {
                  if (!isEmpty(user)) {
                    doLoginAndLaunchRoyalCasino({
                      game_id: "100000",
                      game_name: "Ezugi Lobby",
                      category: "LOBBY",
                      provider_name: "EZUGI",
                      sub_provider_name: "Ezugi",
                      status: "ACTIVE",
                      url_thumb: "https://cdn.hub88.io/ezugi/ezg_blackjackgold5.jpg",
                      game_code: "ezg_lobby",
                    });
                  } else {
                    navigate("/login");
                  }
                }}
                neua="Casino Banner"
              >
                <dl className="entrance-title">
                  <dt>Ezugi</dt>
                  <dd>Play Now</dd>
                </dl>
                <LazyLoadImage
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_ezugi-half.png"
                }
                  
                  alt=""
                />
              </a>

              <a
                className="entrance"
                href="javascript:void(0)"
                onClick={() => {
                  if (!isEmpty(user)) {
                    doLoginAndLaunchRoyalCasino({
                        game_id: "900000",
                      game_name: "Royal Gaming Live Lobby",
                      category: "LOBBY",
                      provider_name: "RG",
                      sub_provider_name: "Royal Gaming Lobby",
                      status: "ACTIVE",
                      url_thumb: "https://cdn.dreamcasino.live/rg_live_lobby.webp",
                      game_code: "RG-LIVELOBBY",
                    });
                  } else {
                    navigate("/login");
                  }
                }}
              >
                <dl className="entrance-title">
                  <dt>Royal Gaming</dt>
                  <dd>Play Now</dd>
                </dl>
                <LazyLoadImage
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_royalgaming.png"
                }
                 
                  alt=""
                />
              </a>
            
          
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "SEXYBCRT",
                    gameType: "LIVE",
                    casinoType: "MX-LIVE-001",
                  });
                } else {
                 handleShow();
                }
              }}
              neua="AEIndia Banner"
            >
              <dl className="entrance-title">
                <dt>SKYCASINO</dt>
                <dd>Play Now</dd>
              </dl>
              <LazyLoadImage 
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_skycasino-half.png"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "1",
                    gameType: "",
                    casinoType: "",
                  });
                } else {
                 handleShow();
                }
              }}
              neua="Casino Banner"
            >
              <dl className="entrance-title">
                <dt>Live Casino</dt>
                <dd>Play Now</dd>
              </dl>
              <LazyLoadImage 
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_casino-half.png"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "SPRIBE",
                    gameType: "",
                    casinoType: "",
                  });
                } else {
                 handleShow();
                }
              }}
              neua="Casino Banner"
            >
              <dl className="entrance-title">
                <dt>Spribe</dt>
                <dd>Play Now</dd>
              </dl>
              <LazyLoadImage 
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_spribe.png"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "",
                    gameType: "",
                    casinoType: "",
                  });
                } else {
                 handleShow();
                }
              }}
              neua="Casino Banner"
            >
              <dl className="entrance-title">
                <dt>7mojo</dt>
                <dd>Play Now</dd>
              </dl>
              <LazyLoadImage 
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/7mojo.jpeg"
                }
                alt=""
              />
            </a> 
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "HORSEBOOK",
                    gameType: "LIVE",
                    casinoType: "HRB-LIVE-001",
                  });
                } else {
                 handleShow();
                }
              }}
              neua="32Cards Banner"
            >
              <dl className="entrance-title">
                <dt>Horcebook</dt>
                <dd>Play Now</dd>
              </dl>
              <LazyLoadImage 
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_horsebook-half.png"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-042",
                  });
                } else {
                 handleShow();
                }
              }}
              href="javascript:void(0)"
              neua="TeenPatti Banner"
            >
              <dl className="entrance-title">
                <dt>Minesweeper</dt>
                <dd>Play Now</dd>
              </dl>
              <LazyLoadImage 
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/mine.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-016",
                  });
                } else {
                  handleShow();
                }
              }}
            >
              <dl className="entrance-title">
                <dt>TeenPatti 20-20</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_TeenPatti2020-half.png"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-005",
                  });
                } else {
                  handleShow();
                }
              }}
            >
              <dl className="entrance-title">
                <dt>NumberKing</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_NumberKing-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-007",
                  });
                } else {
                  handleShow();
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Big small</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_BigSmall-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-010",
                  });
                } else {
                  handleShow();
                }
              }}
              neua="ROYAL Banner"
            >
              <dl className="entrance-title">
                <dt>Teen Patti Joker</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_TeenPattiJoker-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-011",
                  });
                } else {
                  handleShow();
                }
              }}
            >
              <dl className="entrance-title">
                <dt>7updown</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_7up7down-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-012",
                  });
                } else {
                  handleShow();
                }
              }}
              neua="Rummy Banner"
            >
              <dl className="entrance-title">
                <dt>Dragon Tiger</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_DragonNTiger-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-013",
                  });
                } else {
                  handleShow();
                }
              }}
              neua="Rummy Banner"
            >
              <dl className="entrance-title">
                <dt>Callbreak Quick</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_CallbreakQuick-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-017",
                  });
                } else {
                  handleShow();
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Sic bo</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_SicBo-Jili-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-014",
                  });
                } else {
                  handleShow();
                }
              }}
              neua="Rummy Banner"
            >
              <dl className="entrance-title">
                <dt>Baccarat</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_Baccarat-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-043",
                  });
                } else {
                 handleShow();
                }
              }}
              href="javascript:void(0)"
              neua="7Up7Down Banner"
            >
              <dl className="entrance-title">
                <dt>Bonus Dice</dt>
                <dd>Play Now</dd>
              </dl>
              <LazyLoadImage 
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_BonusDice-half.png"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-047",
                  });
                } else {
                 handleShow();
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Heist</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_Heist-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-049",
                  });
                } else {
                 handleShow();
                }
              }}
              neua="ROYAL Banner"
            >
              <dl className="entrance-title">
                <dt>5 Card Poker</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
              <img
              
                src={
                  process.env.REACT_APP_WEB_URL + "/assets/images/home/banner_5CardPoker-half.webp"
                }
                alt=""
               
              />
            </a>
            <a
              className="entrance-half"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-050",
                  });
                } else {
                 handleShow();
                }
              }}
              href="javascript:void(0)"
              neua="7Up7Down Banner"
            >
              <dl className="entrance-title">
                <dt>Color Game</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_ColorGame-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-039",
                  });
                } else {
                 handleShow();
                }
              }}
              neua="32Cards Banner"
            >
              <dl className="entrance-title">
                <dt>32 Cards</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_32card-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-004",
                  });
                } else {
                 handleShow();
                }
              }}
              neua="Rummy Banner"
            >
              <dl className="entrance-title">
                <dt>Rummy</dt>
                <dd>Play Now</dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_rummy-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "BG",
                    gameType: "",
                    casinoType: "",
                  });
                } else {
                 handleShow();
                }
              }}
              neua="ROYAL Banner"
            >
              <dl className="entrance-title">
                <dt>Bet Games</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
              <img
              
                src={
                  process.env.REACT_APP_WEB_URL + "/assets/images/home/banner_betgames-half.webp"
                }
                alt=""
               
              />
            </a>
            
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-032",
                  });
                } else {
                 handleShow();
                }
              }}
              neua="Rummy Banner"
            >
              <dl className="entrance-title">
                <dt>Andar Bahar</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_andarBahar-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-015",
                  });
                } else {
                 handleShow();
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Sicbo</dt>
                <dd>Play Now</dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_sicbo-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-028",
                  });
                } else {
                 handleShow();
                }
              }}
            >
              <dl className="entrance-title">
                <dt>7 Up 7 Down</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_sevenUpDown-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-036",
                  });
                } else {
                 handleShow();
                }
              }}
              href="javascript:void(0)"
              neua="Sicbo Banner"
            >
              <dl className="entrance-title">
                <dt>Coin Toss</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_CoinToss-half.webp"
                }
                alt=""
              />
            </a> 
            <a
              className="entrance-half"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-036",
                  });
                } else {
                 handleShow();
                }
              }}
              href="javascript:void(0)"
              neua="Sicbo Banner"
            >
              <dl className="entrance-title">
                <dt>Teen Patti</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_teenPatti-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-022",
                  });
                } else {
                 handleShow();
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Card Matka</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_cardMatka-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-021",
                  });
                } else {
                 handleShow();
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Number Matka</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_numberMatka-half.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              id="pokerLoginBtn"
              neua="Bpoker Banner"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "",
                    gameType: "",
                    casinoType: "",
                  });
                } else {
                 handleShow();
                }
              }}
              href="javascript:void(0)"
            >
              <dl className="entrance-title">
                <dt>Bpoker</dt>
                <dd>Play Now</dd>
              </dl>
              <img
                src={
                  process.env.REACT_APP_WEB_URL +
                  "/assets/images/home/banner_bpoker-half.webp"
                }
                alt=""
              />
            </a>

            
          </div>
        </Container>
        
      </div>
    </div>
  );
}

export default Home;
